import React,{useEffect,useState} from 'react'
import { DemoPageStyle } from './Demo.styled'
import TopBar from '../../components/TopBar/TopBar'
import { HeadingStyle } from '../../styles/HeadingStyles'
import { useDB } from '../../context/DynamoDBContext'
import { useQuery,useQueryClient } from '@tanstack/react-query'
import { useReload } from '../../context/ReloadContext'
import { getDemoUserList } from '../../api/DemoApi'
import { toast } from 'react-toastify'
import TotalNoCard from '../../components/TotalNoCard/TotalNoCard'
import Footer from '../../components/footer/Footer'
import { useNavigate } from 'react-router-dom';
import ROUTE from '../../common/Routes'
import { MainBodyStyle, MainStyles } from '../../styles/MainBodyStyles'

const DemoPage = () => {
    const {dynamoDBClient}=useDB()
    const queryClient = useQueryClient()
    const [enableAPI, setEnableAPI] = useState(false)
    const {reload}=useReload()
    const [demoUsers, setDemoUsers] = useState([])
    const navigate=useNavigate()

    const handleError=(type)=>{
        if(type==="getDemoUsers"){
            toast.error("Error while loading Demo Users",{
                bodyClassName:"notification-div-error",
                progressClassName:"progress-bar-error"
            })
        }
    }
    

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    useEffect(() => {
      if(dynamoDBClient){
        setEnableAPI(true)
      }else{
        setEnableAPI(false)
      }
    }, [dynamoDBClient])


    useEffect(() => {
      if(reload){
        queryClient.fetchQuery(["getDemoUsers"])
      }
    }, [reload])

    const calculateDemoUser=(data)=>{
      
      const emailMap=data.reduce((acc,record)=>{
        if(!acc[record.Email]){
          acc[record.Email]=[]
        }

        acc[record.Email].push(record)

        return acc

      },{})

      const result=Object.keys(emailMap).map(email=>({
        email:email,
        records:emailMap[email]
      }))
      
      setDemoUsers(result)
    }


    const {
        data:demoList,
        status:demoStatus
    }=useQuery({
        queryKey:["getDemoUsers"],
        queryFn:()=>getDemoUserList(dynamoDBClient),
        enabled:enableAPI,
        onSuccess:(data)=>{
          
          if(data.length>0){
            calculateDemoUser(data)
          }
        },
        onError:(error)=>{
            console.log("getDemoUsers :",error)
            handleError("getDemoUsers")
        }
    })

  return (
    <DemoPageStyle>
        <TopBar authorized={true}  />
        <MainBodyStyle>
            <HeadingStyle>Demo Users</HeadingStyle>
            <MainStyles>
              {demoUsers.length==0 && <p className='noDemoUser'>{demoStatus=="loading"? "Loading Users" : "No Demo User Available"}</p>}
              
              {
                demoUsers.map((item,index)=>
                  <TotalNoCard key={index} heading={`Demo User ${index+1}`} total={item.email} onClick={()=>navigate(ROUTE.DemoGraph,{state:{user:item}})}  />
                )
              }
            </MainStyles>
        </MainBodyStyle>
        <Footer style="footer" />
    </DemoPageStyle>
  )
}

export default DemoPage